module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dates text-dark"
  }, [_c('div', {
    staticClass: "dates__header"
  }, [_c('ChangeSchoolYear', {
    staticClass: "fit-content dates__change-schoolyear",
    attrs: {
      "whiteTheme": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dates-input-group"
  }, [_c('label', [_vm._v("Select the start and end dates for insertion")]), _vm._v(" "), _c('Datepickerrange', {
    attrs: {
      "startdate": _vm.startDate,
      "enddate": _vm.endDate
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": _vm.setEndDate
    }
  })], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bg-color": "#fff"
    }
  }) : _c('div', {
    staticClass: "dates-input-group marg-1-top"
  }, [_c('p', {
    staticClass: "text-explainer"
  }, [_c('b', [_vm._v("Hint:")]), _vm._v(" Click on a day to exclude/include day in rotation")]), _vm._v(" "), _vm._l((_vm.groupedDatesByMonth), function(monthData, month) {
    return _c('div', {
      key: month,
      staticClass: "cal-month"
    }, [_c('h3', [_vm._v(_vm._s(month))]), _vm._v(" "), _c('ul', {
      staticClass: "cal-month__header"
    }, [_c('li', [_vm._v("Mon")]), _vm._v(" "), _c('li', [_vm._v("Tue")]), _vm._v(" "), _c('li', [_vm._v("Wed")]), _vm._v(" "), _c('li', [_vm._v("Thu")]), _vm._v(" "), _c('li', [_vm._v("Fri")]), _vm._v(" "), _c('li', [_vm._v("Sat")]), _vm._v(" "), _c('li', [_vm._v("Sun")])]), _vm._v(" "), _c('ul', {
      staticClass: "cal-month__body"
    }, [_vm._l((monthData.emptyDays), function(n) {
      return _c('li', [_vm._v(" ")])
    }), _vm._v(" "), _vm._l((monthData.dates), function(dateObj, i) {
      return _c('li', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            arrow: true,
            zIndex: 123123123123
          }),
          expression: "{\n                  arrow: true,\n                  zIndex: 123123123123\n                }"
        }],
        key: i,
        staticClass: "cal-month__body__day",
        class: [{
            'cal-month__body__day--can-be-toggled': !dateObj.isVacationDay && !dateObj.isWeekend
          },
          {
            'cal-month__body__day--holiday': dateObj.isVacationDay
          },
          {
            'cal-month__body__day--inactive': !dateObj.isIncluded
          },
          {
            'cal-month__body__day--is-weekend': dateObj.isWeekend
          }
        ],
        attrs: {
          "content": dateObj.isWeekend ? 'Weekend' : dateObj.isVacationDay ? 'Vacation day' : dateObj.isIncluded ? 'Exclude day in rotation' : 'Include day in rotation'
        },
        on: {
          "click": function($event) {
            return _vm.toggleDate(dateObj)
          }
        }
      }, [_c('p', {
        staticClass: "cal-month__body__date"
      }, [_vm._v(_vm._s(dateObj.formattedDate))]), _vm._v(" "), (dateObj.dayToInsert) ? _c('p', {
        staticClass: "cal-month__body__date__to-insert"
      }, [_vm._v(_vm._s(dateObj.dayToInsert.label))]) : _vm._e()])
    })], 2)])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42707fe6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CopyCalendarRotate/CopyCalendarRotateDates.vue
// module id = 1879
// module chunks = 1